<template>
  <div
    class="rewards"
    :class="columnStyle ? '-column' : ''"
  >
    <div class="first-info">
      <img
        :src="coin.program_image"
        class="img"
      />
      <span class="value">{{ value }}</span>
    </div>
    <span class="name">{{ coin.program_name }}</span>
  </div>
</template>

<script>
export default {
  name: 'EngagementCoin',
  props: {
    coin: Object,
    value: Number,
    columnStyle: Boolean
  }
}
</script>

<style lang='scss' scoped>
@import '~@style/reference';
.rewards {
    display: flex;

  &.-column {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
  }

  .first-info {
    display: flex;
  }

  .img {
    width: 24px;
    height: 24px;
    object-fit: cover
  }

  .value {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    align-items: center;
    color: #121E48;
    padding: 0 6px;
  }

  .name {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 11px;
    display: flex;
    align-items: center;
    color: #121E48;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Engagement/Components/EngagementCoin.vue